import React, { ButtonHTMLAttributes } from 'react';
import './Button.css';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  buttonText: string;
  className?: string;
}

const Button: React.FC<Props> = ({
  buttonText,
  disabled,
  type,
  className,
  style,
  onClick,
}: Props) => {
  return (
    <button
      type={type || 'button'}
      className={`button ${className || ''}`}
      disabled={disabled || false}
      style={style}
      onClick={onClick}
    >
      {buttonText}
    </button>
  );
};

export default Button;
